module.exports = __webpack_public_path__ + "assets/checkbox.33950d05.svg";